import { clsx } from 'clsx';

export const AiUnreadReplyBadge = ({ className, label }) => (
    <span
        className={clsx('relative inline-flex size-2', className)}
        aria-hidden='true'
        title={label}
    >
        <span className='absolute inset-0 rounded-full bg-green-400 opacity-75 animate-ping motion-reduce:animate-none' />
        <span className='relative size-full rounded-full bg-green-500' />
    </span>
);
